import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"
import {get} from "lodash"
import Query from "../Query"
import {driverFieldsFragment} from "../../gql/fragments/driver"

const query = gql`
 query CustomDriver ($params: DriversParams!) {
    drivers (params: $params) {
     results {
        ...driverFields
     }
    }
  }
  ${driverFieldsFragment}
`

const GetCustomDriverWizard = ({children, ...props}) => {
  const variables = {params: {contentId: "insights.driver.custom"}}
  return (
    <Query query={query} variables={variables} {...props}>
      {({data: {drivers} = {}, ...apolloState}) => {
        const driver = get(drivers, "results[0]") || {}
        return children({driver, ...apolloState})
      }}
    </Query>
  )
}

GetCustomDriverWizard.propTypes = {
  children: PropTypes.func.isRequired
}

export default GetCustomDriverWizard
